import { Text, Select, Label, Input } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { AppButton, AppLoader } from "../../../../components/common";
import { settingsService } from "../../../../services";
import { IWorkingHourSetting } from "../../../../services/types/settings";
import { monthNames } from "../../../../utils/consts";
import useStyles from "./SettingsStyles";

const WorkingHoursSettingsView: React.FC = () => {
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [settings, setSettings] = useState<
    IWorkingHourSetting[]
  >([]);
  const [year, setYear] = useState<number>(new Date().getFullYear());

  const onYearSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setYear(parseInt(e.target.value));
  };

  const fetchSettings = async () => {
    setIsLoading(true);
    const response = await settingsService.getWorkingHoursSettings(year);
    setSettings(response);
    setIsLoading(false);
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      await settingsService.saveWorkingHoursSettings(year, settings);
    } finally {
      setIsSaving(false);
    }
  };

  const getMonthName = (month: number) => {
    return month >= 1 && month <= 12 ? monthNames[month - 1] : "";
  };

  const handleChangeValue = (value: string, index: number) => {
    const workHours = parseInt(value) || 0;
    const newSettings = [...settings];
    newSettings[index].hours = workHours;
    setSettings(newSettings);
  };

  useEffect(() => {
    fetchSettings();
  }, [year]);

  return (
    <div className={styles.root}>
      <Text size={600} weight="semibold" className={styles.title}>
        Konfiguracja godzin roboczych
      </Text>
      <Text>
        Ustawienia są globalne dla organizacji i wpływają na wyliczenia w „Rozliczeniu godzin usług”.
      </Text>
      <div className={styles.workHoursFilter}>
        Rok:
        <Select
          className={styles.workHoursYearSelect}
          onChange={onYearSelect}
          value={year}
        >
          {Array.from({ length: 26 }, (_, i) => 2020 + i).map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </Select>
      </div>
      {isLoading ? (
        <div className={`${styles.loaderHeight}`}>
          <AppLoader />
        </div>
      ) : (
        <>
          <div>
            {settings?.map((item, index) => (
              <div className={styles.workHourMonthEdit}>
                <>
                  <Label style={{ width: 150 }}>
                    {`${getMonthName(item.month)}`}
                  </Label>
                  <Input
                    type="number"
                    min={1}
                    step={1}
                    value={item.hours?.toString()}
                    onChange={(e) => handleChangeValue(e.target.value, index)}
                  />
                </>
              </div>
            ))}
          </div>
          <div className={styles.buttonContainer}>
            <AppButton
              onClick={handleSave}
              disabled={isSaving}
              text="Zapisz zmiany"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default WorkingHoursSettingsView;
